import Cookies from "js-cookie";
import jwt_decode from "jwt-decode";

export const COOKIE_JWT_ACCESS_TOKEN = "jwtac";
export const COOKIE_JWT_ID_TOKEN = "jwtid";

export const addCookie = (name: string, token: string, expiry: number) => {
  const date = new Date(expiry * 1000);
  Cookies.set(name, token, { expires: date, secure: true });
};

export const getCookie = (name: string) => {
  const token = Cookies.get(name);
  if (!isTokenValid(token)) {
    removeCookie(name);
    return null;
  }
  return token;
};

export const removeCookie = (name: string) => {
  Cookies.remove(name);
};

export const decodeToken = (token: string): any => {
  return jwt_decode(token);
};

export const getUser = () => {
  const token = Cookies.get(COOKIE_JWT_ID_TOKEN);
  if (token) {
    const tokenJson = decodeToken(token);
    if (tokenJson.exp * 1000 > Date.now()) {
      return {
        firstName: tokenJson.given_name,
        lastName: tokenJson.family_name,
        email: tokenJson.email,
      };
    }
  }
  return null;
};

export const getSessionTimeLeftMinutes = () => {
  const token = Cookies.get(COOKIE_JWT_ID_TOKEN);
  if (token) {
    const tokenJson = decodeToken(token);
    return Math.round((tokenJson.exp * 1000 - Date.now()) / 1000 / 60);
  }
  return 0;
};

const isTokenValid = (token: string) => {
  if (!token) {
    return false;
  }
  const tokenJson = decodeToken(token);
  return tokenJson.exp * 1000 > Date.now();
};
